import { render, staticRenderFns } from "./wxplantrans.vue?vue&type=template&id=508c2a52&scoped=true&"
import script from "./wxplantrans.vue?vue&type=script&lang=js&"
export * from "./wxplantrans.vue?vue&type=script&lang=js&"
import style0 from "./wxplantrans.vue?vue&type=style&index=0&id=508c2a52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c2a52",
  null
  
)

export default component.exports